import { render, staticRenderFns } from "./TalentList.vue?vue&type=template&id=7d8c6db4"
import script from "./TalentList.vue?vue&type=script&lang=js"
export * from "./TalentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports